import { FloatingDiv } from 'articleEditor/components/floatingDiv/floatingDiv';
import { Toolbar } from 'articleEditor/components/toolbar';
import useSelectionHover from 'articleEditor/hooks/useSelectionHover';

import FormatButton from './formatButton';
import LinkToolbarButton from './linkButton';

export function ContextMenu(): JSX.Element {
  // const linkMenuOpen = useFloatingInterlinkSelectors().isOpen(editor.id);
  const floatingProps = useSelectionHover('contextMenu', {
    // disabling as it prevents context selection menu from showing when selecting text with a link
    // forcedClosed: linkMenuOpen,
  });

  // ID is so that floating-ui can target it.
  return (
    <FloatingDiv id="contextMenu" floatingProps={floatingProps} withDisabling>
      <Toolbar>
        <FormatButton icon="bold" mark="bold" />
        <FormatButton icon="italic" mark="italic" />
        <FormatButton icon="underline" mark="underline" />
        <FormatButton icon="ban" mark="strikethrough" />
        <FormatButton icon="code" mark="code" />

        <LinkToolbarButton />
        {/* TODO: later! */}
        {/* <button className={s['contextMenuButton']} tabIndex={-1}>
        <Icon className={s['contextMenuIcon']} name="dots-h" />
      </button> */}
      </Toolbar>
    </FloatingDiv>
  );
}
